import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/pill.svg` */
export const PillSolidIcon = createTripletGlyphIcon('PillSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2172 1.74616C12.946 1.79986 14.3469 3.24509 14.3471 4.97467V11.2032C14.3471 12.4271 13.6444 13.4625 12.6215 13.9464C12.1931 14.1567 11.7062 14.269 11.1889 14.253C9.47535 14.1999 8.08638 12.7672 8.08638 11.0528V4.78034L8.09029 4.62018C8.17427 2.96796 9.54234 1.69431 11.2172 1.74616ZM11.2172 2.84577C10.0956 2.81105 9.18631 3.69246 9.18599 4.81452V7.99713L13.2485 8.04889V4.94049C13.2483 3.81843 12.3388 2.88067 11.2172 2.84577Z"
        fill="currentColor"
      />
      <path
        d="M7.51509 8.73541C7.72968 9.43278 7.68102 10.1848 7.37838 10.8487C7.07565 11.5125 6.53963 12.0426 5.87252 12.338C5.20535 12.6328 4.45198 12.6727 3.75728 12.4503C3.06289 12.2277 2.47364 11.7583 2.10201 11.1309L7.51509 8.73541Z"
        fill="currentColor"
      />
      <path
        d="M3.4272 6.73151C4.09434 6.43664 4.84679 6.39689 5.54146 6.6192C6.23615 6.84166 6.82585 7.311 7.19771 7.93854L1.78463 10.334C1.57008 9.63674 1.61874 8.88461 1.92134 8.22077C2.22404 7.55693 2.76007 7.02686 3.4272 6.73151Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6182 1.96435C14.563 2.02469 16.1404 3.65139 16.1406 5.59716V12.604C16.1406 14.0146 15.311 15.2049 14.1143 15.731C13.6531 15.9416 13.1351 16.0526 12.5869 16.0356C10.6592 15.9759 9.09669 14.3638 9.09669 12.4351V12.4194L9.09571 12.3862V5.37939L9.10059 5.19872C9.19483 3.33992 10.734 1.90629 12.6182 1.96435ZM12.6182 3.06396C11.2808 3.02284 10.1968 4.07463 10.1963 5.41259V8.9956L15.041 9.05908V5.56298C15.0407 4.22473 13.9558 3.1055 12.6182 3.06396Z"
        fill="currentColor"
      />
      <path
        d="M8.45411 9.82861C8.69536 10.6131 8.64033 11.4597 8.29981 12.2065C7.9592 12.953 7.35676 13.5492 6.60645 13.8813C5.85591 14.2132 5.0091 14.2585 4.22755 14.0083C3.4462 13.7581 2.78355 13.2297 2.36524 12.5239L8.45411 9.82861Z"
        fill="currentColor"
      />
      <path
        d="M3.85548 7.57372C4.60612 7.24199 5.45279 7.19749 6.23438 7.44775C7.01575 7.69807 7.67842 8.22625 8.09669 8.93212L2.00782 11.6274C1.76643 10.843 1.82076 9.99633 2.16114 9.24951C2.50172 8.50259 3.10482 7.90597 3.85548 7.57372Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8251 2.61924C19.4185 2.69962 21.5213 4.86828 21.5214 7.46299V16.8058C21.5213 18.7049 20.3941 20.3048 18.7733 20.9952C18.1701 21.2625 17.4958 21.403 16.7831 21.381C14.2126 21.3014 12.1288 19.1519 12.1288 16.5802V7.17197C12.1289 4.57725 14.2316 2.53895 16.8251 2.61924ZM16.8251 3.91904C14.9493 3.86097 13.4288 5.33535 13.4286 7.21201V11.9933L20.2216 12.0802V7.42295C20.2215 5.54621 18.7009 3.97721 16.8251 3.91904Z"
        fill="currentColor"
      />
      <path
        d="M11.2723 13.1036C11.5942 14.1497 11.5212 15.2777 11.0673 16.2735C10.6132 17.2693 9.80923 18.0639 8.80847 18.5069C7.80757 18.9495 6.67885 19.0096 5.63659 18.6759C4.59443 18.3421 3.71087 17.6379 3.1532 16.6964L11.2723 13.1036Z"
        fill="currentColor"
      />
      <path
        d="M5.1405 10.0978C6.14138 9.65535 7.27019 9.59515 8.31238 9.92881C9.35435 10.2625 10.238 10.967 10.7958 11.9083L2.67663 15.5011C2.35481 14.455 2.42762 13.327 2.88171 12.3312C3.33586 11.3353 4.13961 10.5407 5.1405 10.0978Z"
        fill="currentColor"
      />
    </svg>
  ),
});
